<template>
<div style="height: 100%;margin: 0 10px;overflow-y: hidden">
  <el-table height="100%" class="table-list" :header-cell-style="getBackgroundColor" :row-class-name="tableRowClassName" :cellStyle="cellStyle" :data="tableData" style="width: 100%" size="mini">
    <el-table-column
      label="工单号"
      width="75"
      :resizable="true"
      show-overflow-tooltip>
      <template slot-scope="scope">
<!--        <marquee scrollamount="3">{{scope.row.id}}</marquee>-->
        <span>{{scope.row.id}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="用户姓名"
      min-width="55"
      :resizable="true"
      align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.person && scope.row.person.name">{{scope.row.person.name}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="事件类型"
      min-width="55"
      :resizable="true"
      align="center">
      <template slot-scope="scope">
        <span>{{getAType(scope.row.alarmtype)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="接单员工号"
      min-width="70"
      :resizable="true"
      show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.jobnum}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="接单人员"
      min-width="70"
      :resizable="true"
      show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.p_name}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="开始时间"
      min-width="90"
      :resizable="true"
      show-overflow-tooltip
      align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.handletime === '-'">{{scope.row.handletime}}</span>
        <span scrollamount="3" v-else>{{scope.row.handletime}}</span>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>

<script>
export default {
  name: 'leftBottomTable',
  data () {
    return {
      listData: [],
      tableData: [
        {id: '', status: '所有报警', p_name: '处理完成', handletime: ''}
      ]
    }
  },
  created () {
    this.golobleObject.getHandleInfo = this.changeShow
  },
  methods: {
    getListData (arr) {
      // console.log(999, arr)
      this.listData = arr
      this.getAlarmData()
    },
    getAlarmData () {
      if (this.listData.length > 0) {
        this.tableData = []
        for (let i = 0; i < this.listData.length; i++) {
          this.listData[i].status = '待处理'
          this.listData[i].p_name = '-'
          this.listData[i].handletime = '-'
          this.listData[i].jobnum = '-'
        }
        this.changeShow()
      } else {
        this.tableData = [{id: '', status: '所有报警', p_name: '处理完成', handletime: ''}]
      }
    },
    changeShow () {
      const handle = this.store2.state.other.isHandle
      console.log('列表', handle)
      let idList = []
      for (let i = 0; i < handle.length; i++) {
        const obj = handle[i]
        idList.push(parseInt(obj.id))
      }
      this.tableData = []
      for (let i = 0; i < this.listData.length; i++) {
        const alarmObj = this.listData[i]
        if (idList.indexOf(alarmObj.id) > -1) {
          for (let ii = 0; ii < handle.length; ii++) {
            const usernameObj = handle[ii]
            if (usernameObj.id === alarmObj.id) {
              alarmObj.status = '处理中'
              alarmObj.p_name = usernameObj.name
              alarmObj.handletime = usernameObj.time
              alarmObj.jobnum = usernameObj.jobnum
            }
          }
        }
        this.tableData.push(alarmObj)
      }
      console.log('处理列表', this.tableData)
    },
    getAType (alarmtype) {
      return this.commonType.getAlarmType(alarmtype)
    },
    cellStyle ({row, column, rowIndex, columnIndex}) {
      return 'border-color:#1a1a1a!important;font-weight:bold!important'
    },
    getBackgroundColor () {
      return {backgroundColor: '#13213a', color: '#00ffff', borderColor: '#1a1a1a'}
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    }
  }
}
</script>
<style>
.el-table .warning-row {
  background: #051230;
  color: #dadada;
}

.el-table .success-row {
  background: #111a32;
  color: #dadada;
}
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/leftBottomTable.vue